const BASE_URL = 'https://service.fasttoken.com/';

export const TOKEN_PURCHASE_ORDER = `${BASE_URL}email/token-purchase-order`;
export const EMAIL_SUBSCRIPTION = `${BASE_URL}email/subscribe-ftn-claim`;
export const FST_DISTRIBUTION_EVENTS = `${BASE_URL}fst-distribution/events`;
